import React, { useState, useEffect } from 'react';
import {TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from "../api/baseurl";
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from "react-bootstrap";
import { toast } from 'react-toastify';

const EmployeeDetailsPopup = ({ isOpen, onRequestClose, userDetails }) => {
  const [employeeDetails, setEmployeeDetails] = useState({
    name: '',
    lastname: '',
    phoneno: '',
    email: '',
    address: '',
    validate: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (userDetails) {
      setEmployeeDetails(userDetails); // Prepopulate with userDetails
    }
  }, [userDetails]);

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setEmployeeDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleUpdate = async () => {
    try {
      const updatedDetails = {
        ...employeeDetails,
        validate: true,
      };
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.post(`/api/employeedetails/update`, updatedDetails, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 || response.status === 201 || response.status === 202) {
        toast.success("Updated successfully")
        onRequestClose();
      }
    } catch (error) {
      console.error('Error updating employee details:', error);
    }
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
    <Modal.Header closeButton className="justify-content-center">
      <Modal.Title className="w-100 text-center">Profile update</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form noValidate autoComplete="off">
        <div>
          <div>Name: {employeeDetails?.name} {employeeDetails?.lastname}</div>
          <div>Email: {employeeDetails?.email}</div>
        </div>
  
        {/* Phone Number (Editable) */}
        <div className="row">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="contact">Phone Number </label>
                    <input
                      className="form-control"
                      id="phoneno"
                      type="text"
                      placeholder="Phone Number"
                      value={employeeDetails.phoneno}
                      onChange={handleInputChange}
                     
                    />
                  </div>
                </div>
                
  
        {/* Address (Editable) */}
        <div className="row">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="address">Address</label>
                    <textarea
                      className="form-control"
                      id="address"
                      type="text"
                      placeholder="Address"
                      value={employeeDetails.address}
                      onChange={handleInputChange}
                      rows="2"
                      // required
                    />
                 
                </div>
                </div>
        <div className="mt-3">
          <Button variant="primary me-3" onClick={handleUpdate}>
            Update
          </Button>
          <Button variant="secondary" onClick={onRequestClose}>
            Close
          </Button>
        </div>
      </form>
    </Modal.Body>
  </Modal>
    );
};

export default EmployeeDetailsPopup;

